export enum SwiftCardState {
  Existing = 'Existing',
  New = 'New',
  Register = 'Register',
}
